export function VideoPlayer({ src }: { src: string }) {
  return (
    <video
      src={src}
      controls
      playsInline
      preload="metadata"
      className="max-h-[480px] w-full rounded bg-overlay"
    />
  );
}
